import { View } from "react-native";
import { Text } from "@towersystems/roam-common-native";

export interface SectionProps {
  title: string;
  children?: React.ReactNode;
}

export function Section({ title, children }: SectionProps) {
  return (
    <View>
      <Text variant="heading2">{title}</Text>
      {children}
    </View>
  );
}
